import React from "react";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import type { SslMode } from "components/canvas/leftSide/import/Postgres/postgresApi";

interface Option {
  value: SslMode;
  label: string;
  hint: string;
  icon: React.ReactNode;
}

const OPTIONS: Option[] = [
  {
    value: "VerifyFull",
    label: "Encrypt & verify",
    hint: "Strictest",
    icon: <ShieldOutlinedIcon sx={{ fontSize: 16 }} />,
  },
  {
    value: "Encrypt",
    label: "Encrypt only",
    hint: "No cert check",
    icon: <LockOutlinedIcon sx={{ fontSize: 16 }} />,
  },
];

interface Props {
  value: SslMode;
  onChange: (mode: SslMode) => void;
}

export const SslModePicker: React.FC<Props> = ({ value, onChange }) => (
  <div className="flex flex-col gap-2">
    <span className="text-fg-muted-medium">Encryption</span>
    <div
      role="radiogroup"
      aria-label="Encryption mode"
      className="grid grid-cols-2 gap-2"
    >
      {OPTIONS.map((opt) => {
        const selected = value === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(opt.value)}
            className={`flex flex-col gap-1 p-3 border rounded-app bg-bg text-left cursor-pointer transition-colors hover:bg-list-hover ${
              selected ? "border-accent" : "border-border hover:border-accent"
            }`}
          >
            <span className="flex items-center gap-1.5 text-fg-bold">
              <span
                className={selected ? "text-accent" : "text-fg-muted-medium"}
              >
                {opt.icon}
              </span>
              {opt.label}
            </span>
            <span className="text-fg-muted-regular-small">{opt.hint}</span>
          </button>
        );
      })}
    </div>
  </div>
);
